<div class="container-fluid  row_banner pb-5">
    <app-header></app-header>
    <div class="container">
        <div class="row  text-center justify-content-center">
            <div class="col-lg-9 col-md-9 mb-4" id="footergrammartext">
                <h1 class="w-100 fnt-w600-40 tit">AI Cover Letter Generator</h1>
                <!-- Pending -->
                <span class="w-100 d-inline-block main_text mt-40">AI cover letter generator creates job-specific cover
                    letters based on your resume and skills. Enter your details and get
                    a ready-to-use letter in seconds!</span>
            </div>
        </div>
        <!-- Editor -->
        <div class="row  text-center justify-content-center">
            <div class="col-lg-7 col-md-9 col-12 ">
                <div class="custom-card">

                    <form action="">
                        <p class="text-left px-3 alert-danger" id="eFsubText2" [ngStyle]="{'color': color}"
                            *ngIf="eFsubIF ">
                            <i class="fas fa-check-circle" aria-hidden="true"></i>{{eFsubText2}}
                        </p>
                    </form>


                    <form class="aiform">
                        <div>
                            <div class="row group-data" style="justify-content: space-between;">
                                <div class="col form-group ">
                                    <label for="" class="aiLabel">Resume</label>
                                    <input id="form_name" type="text" name="form_name"
                                        class="form-control bd-light p-base" spellcheck="false" data-gramm="false"
                                        placeholder=" Add your resume Information *" value="" />
                                </div>
                                <div class="col form-group ">
                                    <label for="" class="aiLabel">Enter Job tittle </label>
                                    <input id="form_title" type="text" name="form_title"
                                        class="form-control bd-light p-base" spellcheck="false" data-gramm="false"
                                        placeholder=" UX Writer*" value="" />
                                </div>
                            </div>
                            <div class="">
                                <div class="detail-butn">
                                    <label for="description" class="aiLabel">Add Details</label>
                                    <!-- <button class="sample-btn "> Sample Text</button> -->
                                </div>
                                <textarea id="form_detail" name="form_detail" class="form-control bd-light p-base"
                                    rows="3" spellcheck="false" data-gramm="false"
                                    placeholder="I'm a UX Writer who crafts clear, concise, and user-friendly content to enhance digital experiences."></textarea>
                            </div>

                        </div>
                        <div id="recaptcha-container" data-size="compact" data-theme="light"
                            style="display: flex; justify-content: center;  margin-top: 15px;"></div>
                        <div class="input-group-append btn-submit-div mt-3">
                            <button type="submit" class="btn btn-dark m-0 btn-submit" value="Submit"
                                (click)="eFormSubmission($event)">
                                <i class="fa fa-spinner fa-pulse ml-2 mr-1" *ngIf="loaderAlert"></i> Submit </button>
                            <button *ngIf="output_display" type="submit" class="btn btn-dark m-0 btn-refresh "
                                (click)="reFreshWindow()">
                                Start New Search </button>
                        </div>

                    </form>
                    <div class="outputDisplay mt-3" *ngIf="output_display">
                        <div class="outputtop">
                            <div>
                                <p class="outputtopTxt">
                                    Your Cover Letter is Generated Here
                                </p>
                            </div>

                            <div class="outputtopButton tooltipss" (click)="copyToClipboard()" role="button"
                                tabindex="0" (keydown.enter)="copyToClipboard()">
                                <span class="tooltiptext">Copy</span>
                                <span class="tooltiptext" id="copried_txt" *ngIf="copiedtext">Copied</span>
                                <img src="../../assets/images/About us-assets/copy-frame.svg" alt="copy-frame"
                                    height="18px" width="18px">
                                <p class="">Copy to clipboard</p>
                            </div>
                        </div>
                        <div class="responseD">
                            <div class="responseO" [innerHTML]="output"></div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<main id="cover-letter-generator">
    <section class="top-margin">
        <div class="container">
            <div class="statement-generator">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-6 col-md-9 mb-4">
                        <div class="statement-detail">
                            <h2 class="statement-title mx-auto">
                                Steps to Generate a Cover Letter with AI
                            </h2>
                            <p class="statmente-description">Generating an excellent cover letter for a job at GrammarIn
                                is easier than you think. Follow these quick steps to
                                achieve the best results.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row text-center justify-content-center">
                <div class="col-12 mb-4">
                    <div class="cards ">
                        <div *ngFor="let step of  steps ">
                            <div class="card p-base">
                                <span class="pbg"><app-icons-free-tools [name]="step.icon" /></span>
                                <div class="card-detail">
                                    <span class="card-title"> {{ step.title }}</span>
                                    <span class="card-descrition">{{ step.description }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </section>
    <section class="top-margin">
        <div class="container">
            <div class="introduction p-base">
                <div class="justify-content-center p-base">
                    <img src="/assets/images/punctuation/thesisgenerator.svg" alt="Thesis Statement Generator"
                        class="thesis-statement-generator-img" width="391px" height="338px">
                </div>
                <div class="statement-detail p-base">

                    <h2 class="statement-title mx-auto">Professional AI Cover Letter Generator</h2>
                    <p class="statement-description">A professional AI cover letter generator is designed to help job
                        seekers create personalized and impactful cover letters within seconds. By analyzing your job
                        title, industry, and details, this AI tool creates tailored cover letters that highlight your
                        strengths and passion for the role.It saves you from the trouble of writing a cover letter
                        from scratch, ensures the format is correct, and gives it a professional tone. Whether it’s your
                        first job or a new career move, this innovative tool makes the process easier and helps you get
                        more interview calls.</p>
                </div>


            </div>
        </div>
    </section>

    <section class="top-margin">
        <div class="container">
            <div class="Secure p-base">
                <div class="statement-detail p-base">

                    <h2 class="statement-title mx-auto">Secure Your Job with Our Resume Cover Letter Generator</h2>
                    <p class="statement-description">First impressions matter, especially when applying for a job. A
                        compelling resume cover letter can be the key to landing
                        an interview. GrammarIn’s AI resume cover letter generator is designed to help you make that
                        strong first impression
                        without any stress. It is your fast track for generating standout cover letters, as it saves
                        your time while increasing
                        your chances of getting hired. Try it today and let your resume shine with a professional cover
                        letter AI generator.
                    </p>
                </div>
                <div class="justify-content-center p-base">
                    <img src="/assets/images/punctuation/Your-Job-with-Our-Resume-Cover-Letter-Generator.webp"
                        alt="Secure Your Job" class="thesis-statement-generator-img" width="486px" height="485px">
                </div>



            </div>
        </div>
    </section>

    <section class="common-writing  top-margin">
        <div class="container">
            <div class="row text-center justify-content-center">
                <div class="time-line ">
                    <div class=" me-lg-5 mt-md-4">
                        <h2 class="title mt-3 pr-md-5">
                            Key Features of GrammarIN Cover Letter AI Generator
                        </h2>
                        <p class="description" style="padding-left: 0px">
                            The cover letter AI generator is built to help users generate effective job applications.
                            So, it provides all the
                            advanced features, including:
                        </p>
                    </div>

                    <div class=" martop main-view mt-4 mtsmall">

                        <div class="vertical-tabs-container ">
                            <div class="" id="faq-rows">
                                <div class="nav flex-column nav-pills" id="vertical-tab-list" role="tablist"
                                    aria-orientation="vertical">
                                    <div class="nav-link nav-pills vertical-tabs-pills mtsmall"
                                        [ngClass]="{ active: currentTab === 'tab1' }" (click)="currenttoggleTab('tab1')"
                                        id="vertical-first-tab" aria-controls="tab1" aria-expanded="false"
                                        class="mb-0 collapsed">
                                        <div>
                                            <h3 class="ms-3" style="cursor: pointer;">
                                                <div class="d-flex" id="headPotential">
                                                    <div>
                                                        <span class=" potential-title">Instant Generation</span>
                                                    </div>
                                                </div>
                                            </h3>
                                            <div aria-labelledby="tab1" class="collapse"
                                                [ngClass]="{ show: currentTab === 'tab1' }" id="tab1" role="tabpanel"
                                                data-parent="#vertical-tab-list">
                                                <div class="card-body potential-content ms-3 me-3">
                                                    Our <a href="/cover-letter" style="text-decoration: underline ;">
                                                        cover letter generator </a> works instantly. Just enter your
                                                    details, and you'll get a complete, ready-to-use letter in
                                                    seconds without waiting or any delays.
                                                </div>
                                            </div>
                                        </div>

                                        <div style="cursor: pointer;">
                                            <!-- <img [src]="getIcon('tab1')" alt="writers and authors"
                                                class="float-right mt-3 mr-4 potential-icon" width="16px;"
                                                height="8.69px" style="cursor: pointer;" /> -->
                                            <img [src]="getIcon('tab1')" alt="language learners"
                                                class="float-right mt-3 mr-4 potential-icon"
                                                [style.width]="getIconSize('tab1').width"
                                                [style.height]="getIconSize('tab1').height" style="cursor: pointer;" />
                                        </div>
                                    </div>
                                    <div class="mb-2"></div>
                                    <div class="nav-link nav-pills vertical-tabs-pills"
                                        [ngClass]="{ active: currentTab === 'tab2' }" (click)="currenttoggleTab('tab2')"
                                        id="vertical-second-tab" aria-controls="tab2" aria-expanded="false"
                                        class="mb-0 collapsed">
                                        <div>
                                            <h3 class="ms-3" style="cursor: pointer;">
                                                <div class="d-flex" id="headPotential">
                                                    <div>
                                                        <span class=" potential-title">Job-Specific Targeting</span>
                                                    </div>
                                                </div>
                                            </h3>
                                            <div aria-labelledby="tab2" class="collapse"
                                                [ngClass]="{ show: currentTab === 'tab2' }" id="tab2" role="tabpanel"
                                                data-parent="#vertical-tab-list">
                                                <div class="card-body potential-content ms-3 me-3">
                                                    The tool adapts each cover letter based on the entered job title,
                                                    company name, and relevant experience. So it
                                                    automatically includes role-specific keywords that help make your
                                                    application more relevant to the job.
                                                </div>
                                            </div>
                                        </div>

                                        <div style="cursor: pointer;">
                                            <!-- <img [src]="getIcon('tab2')" alt="language learners"
                                                class="float-right mt-3 mr-4 potential-icon" width="16px;"
                                                height="8.69px" style="cursor: pointer;" /> -->
                                            <img [src]="getIcon('tab2')" alt="language learners"
                                                class="float-right mt-3 mr-4 potential-icon"
                                                [style.width]="getIconSize('tab2').width"
                                                [style.height]="getIconSize('tab2').height" style="cursor: pointer;" />
                                        </div>
                                    </div>
                                    <div class="mb-2"></div>
                                    <div class="nav-link nav-pills vertical-tabs-pills"
                                        [ngClass]="{ active: currentTab === 'tab3' }" (click)="currenttoggleTab('tab3')"
                                        id="vertical-third-tab" aria-controls="tab3" aria-expanded="false"
                                        class="mb-0 collapsed">
                                        <div>
                                            <h3 class="ms-3" style="cursor: pointer;">
                                                <div class="d-flex" id="headPotential">
                                                    <div>
                                                        <span class=" potential-title">Grammar and Style Perfection
                                                        </span>
                                                    </div>
                                                </div>
                                            </h3>
                                            <div aria-labelledby="tab3" class="collapse"
                                                [ngClass]="{ show: currentTab === 'tab3' }" id="tab3" role="tabpanel"
                                                data-parent="#vertical-tab-list">
                                                <div class="card-body potential-content ms-3 me-3">
                                                    Our AI cover letter generator uses <a href="/grammar-checker"
                                                        style="text-decoration: underline ;"> advanced grammar checking
                                                        technology</a> to help you generate a polished and
                                                    well-structured letter. It catches typos and awkward phrasing, so
                                                    your cover letter is clear, professional, and ready to
                                                    impress the readers.
                                                </div>
                                            </div>
                                        </div>

                                        <div style="cursor: pointer;">
                                            <!-- <img [src]="getIcon('tab3')" alt="students & teachers"
                                                class="float-right mt-3 mr-4 potential-icon" width="16px;"
                                                height="8.69px" style="cursor: pointer;" /> -->
                                            <img [src]="getIcon('tab3')" alt="language learners"
                                                class="float-right mt-3 mr-4 potential-icon"
                                                [style.width]="getIconSize('tab3').width"
                                                [style.height]="getIconSize('tab3').height" style="cursor: pointer;" />
                                        </div>
                                    </div>
                                    <div class="mb-2 osmal"></div>

                                    <div class="nav-link nav-pills vertical-tabs-pills"
                                        [ngClass]="{ active: currentTab === 'tab4' }" (click)="currenttoggleTab('tab4')"
                                        id="vertical-forth-tab" aria-controls="tab4" aria-expanded="false"
                                        class="mb-0 collapsed">
                                        <div>
                                            <h3 class="ms-3" style="cursor: pointer;">
                                                <div class="d-flex" id="headPotential">
                                                    <div>
                                                        <span class=" potential-title">ATS (Application Tracking System)
                                                            Friendly Format
                                                        </span>
                                                    </div>
                                                </div>
                                            </h3>
                                            <div aria-labelledby="tab4" class="collapse"
                                                [ngClass]="{ show: currentTab === 'tab4' }" id="tab4" role="tabpanel"
                                                data-parent="#vertical-tab-list">
                                                <div class="card-body potential-content ms-3 me-3">
                                                    This cover letter generator helps create ATS-friendly letters by
                                                    using clear formatting and relevant keywords. This
                                                    makes it easier for Applicant Tracking Systems to scan your content,
                                                    boosting your chances of passing the initial
                                                    screening and getting noticed by employers.
                                                </div>
                                            </div>
                                        </div>

                                        <div style="cursor: pointer;">
                                            <!-- <img [src]="getIcon('tab4')" alt="business professionals"
                                                class="float-right mt-3 mr-4 potential-icon" width="16px;"
                                                height="8.69px" style="cursor: pointer;" /> -->
                                            <img [src]="getIcon('tab4')" alt="language learners"
                                                class="float-right mt-3 mr-4 potential-icon"
                                                [style.width]="getIconSize('tab4').width"
                                                [style.height]="getIconSize('tab4').height" style="cursor: pointer;" />
                                        </div>
                                    </div>
                                    <div class="mb-2 osmal"></div>
                                </div>
                            </div>
                        </div>

                    </div>


                </div>
            </div>
        </div>
    </section>
    <section class="top-margin">
        <div class="container">
            <div class="statement-generator">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-8 col-md-9 mb-4">
                        <div class="statement-detail">
                            <h2 class="statement-title mx-auto">
                                Why Use Our AI Cover Letter Generator
                            </h2>
                            <p class="statmente-description">Our AI Cover Letter Generator makes creating a
                                professional, job-ready cover letter quick and effortless. It streamlines
                                the process for all job seekers, including fresh graduates and experienced
                                professionals. Some prominent aspects are
                                discussed below:</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="use-cards ">
                <div *ngFor="let step of  Formats ">
                    <div class="use-card p-base ">
                        <span class="pbg"><app-icons-free-tools [name]="step.icon" /></span>
                        <div class="card-detail" style="gap: 0.5rem">
                            <span class="card-title"> {{ step.title }}</span>
                            <span class="card-descrition">{{ step.description }}</span>
                        </div>
                    </div>
                </div>
            </div>




        </div>
    </section>




    <section class="fqa margin-top-bottom top-margin">
        <div class="container">
            <div class="row text-center justify-content-center">
                <div class="col-lg-9 col-12 mb-md-4 mb-2">
                    <h2 class="headings">Frequently Asked Questions</h2>
                </div>
            </div>

            <div class="v-pills-tab-list">
                <div class="" id="row_faqs">
                    <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                        <div class="container container-grid" style="width: min(100% - 40px, 768px)">
                            <div class="nav-link nav-pills" [ngClass]="{ active: activeTab === 'q1' }"
                                (click)="toggleTab('q1')" id="v-pills-first-tab" aria-controls="q1"
                                aria-expanded="false">
                                <div class="nav-linkFAQ">
                                    <h3 class="card-header" [class.closed]="activeTab !== 'q1'">
                                        Is This Cover Letter Unique or Generic?
                                    </h3>
                                    <app-icons-free-tools name="plusIcon" *ngIf="activeTab !== 'q1'" />
                                    <app-icons-free-tools name="minusIcon" *ngIf="activeTab === 'q1'" />
                                </div>

                                <div aria-labelledby="q1" class="collapse" [ngClass]="{ show: activeTab === 'q1' }"
                                    id="q1" role="tabpanel" data-parent="#v-pills-tab-list">
                                    <div class="card-body">
                                        The AI cover letter generator creates unique letters based on the details you
                                        enter. You can create as many unique cover
                                        letters as you want by simply updating your information each time.
                                    </div>
                                </div>
                            </div>

                            <div class="nav-link nav-pills" [ngClass]="{ active: activeTab === 'q2' }"
                                (click)="toggleTab('q2')" id="v-pills-2nd-tab" aria-controls="q2" aria-expanded="false">
                                <div class="d-flex nav-linkFAQ">
                                    <h3 class="card-header" [class.closed]="activeTab !== 'q2'">
                                        Is It Safe to Use an AI Cover Letter Generator Online?

                                    </h3>

                                    <app-icons-free-tools name="plusIcon" *ngIf="activeTab !== 'q2'" />
                                    <app-icons-free-tools name="minusIcon" *ngIf="activeTab === 'q2'" />
                                </div>

                                <div aria-labelledby="q2" class="collapse" [ngClass]="{ show: activeTab === 'q2' }"
                                    id="q2" role="tabpanel" data-parent="#v-pills-tab-list">
                                    <div class="card-body">
                                        Yes, our AI cover letter generator is safe to use. We protect your personal
                                        information and only use your details to
                                        create your cover letter.

                                    </div>
                                </div>
                            </div>

                            <div class="nav-link nav-pills" [ngClass]="{ active: activeTab === 'q3' }"
                                (click)="toggleTab('q3')" id="v-pills-3rd-tab" aria-controls="q3" aria-expanded="false">
                                <div class="nav-linkFAQ">
                                    <h3 class="card-header" [class.closed]="activeTab !== 'q3'">
                                        Can This Tool Create a Cover Letter for Any Job I Apply To?
                                    </h3>

                                    <app-icons-free-tools name="plusIcon" *ngIf="activeTab !== 'q3'" />
                                    <app-icons-free-tools name="minusIcon" *ngIf="activeTab === 'q3'" />
                                </div>

                                <div aria-labelledby="q3" class="collapse" [ngClass]="{ show: activeTab === 'q3' }"
                                    id="q3" role="tabpanel" data-parent="#v-pills-tab-list">
                                    <div class="card-body">
                                        Absolutely. Our tool adapts to your job title and industry very well. It is
                                        designed to provide relevant content,
                                        whether you are applying for a role in IT, marketing, customer service, or
                                        education.
                                    </div>
                                </div>
                            </div>

                            <div class="nav-link nav-pills" [ngClass]="{ active: activeTab === 'q4' }"
                                (click)="toggleTab('q4')" id="v-pills-4th-tab" aria-controls="q4" aria-expanded="false">
                                <div class="nav-linkFAQ">
                                    <h3 class="card-header faqHeading" [class.closed]="activeTab !== 'q4'">
                                        Is This Cover Letter Generator Free for All?
                                    </h3>

                                    <app-icons-free-tools name="plusIcon" *ngIf="activeTab !== 'q4'" />
                                    <app-icons-free-tools name="minusIcon" *ngIf="activeTab === 'q4'" />
                                </div>

                                <div aria-labelledby="q4" class="collapse" [ngClass]="{ show: activeTab === 'q4' }"
                                    id="q4" role="tabpanel" data-parent="#v-pills-tab-list">
                                    <div class="card-body">
                                        Yes, our cover letter generator is free to use for everyone. You can create
                                        professional cover letters at no cost.
                                    </div>
                                </div>
                            </div>

                            <div class="nav-link nav-pills" [ngClass]="{ active: activeTab === 'q5' }"
                                (click)="toggleTab('q5')" id="v-pills-5th-tab" aria-controls="q5" aria-expanded="false">
                                <div class="nav-linkFAQ">
                                    <h3 class="card-header faqHeading" [class.closed]="activeTab !== 'q5'">
                                        Can I Edit the Cover Letter After It's Generated?
                                    </h3>

                                    <app-icons-free-tools name="plusIcon" *ngIf="activeTab !== 'q5'" />
                                    <app-icons-free-tools name="minusIcon" *ngIf="activeTab === 'q5'" />
                                </div>

                                <div aria-labelledby="q5" class="collapse" [ngClass]="{ show: activeTab === 'q5' }"
                                    id="q5" role="tabpanel" data-parent="#v-pills-tab-list">
                                    <div class="card-body">
                                        Yes, you can edit the cover letter after it's generated. Once the letter is
                                        created, you’re free to make any changes to
                                        better match your style or add extra details before using it.

                                    </div>
                                </div>
                            </div>

                            <div class="nav-link nav-pills" [ngClass]="{ active: activeTab === 'q6' }"
                                (click)="toggleTab('q6')" id="v-pills-6th-tab" aria-controls="q6" aria-expanded="false">
                                <div class="nav-linkFAQ">
                                    <h3 class="card-header faqHeading" [class.closed]="activeTab !== 'q6'">
                                        Can I Use This Cover Letter Generator Multiple Times?
                                    </h3>

                                    <app-icons-free-tools name="plusIcon" *ngIf="activeTab !== 'q6'" />
                                    <app-icons-free-tools name="minusIcon" *ngIf="activeTab === 'q6'" />
                                </div>

                                <div aria-labelledby="q6" class="collapse" [ngClass]="{ show: activeTab === 'q6' }"
                                    id="q6" role="tabpanel" data-parent="#v-pills-tab-list">
                                    <div class="card-body">
                                        Definitely! You can create different versions for different jobs. Each time you
                                        update the job title or experience
                                        details, the tool generates a new draft based on the input data.
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</main>

<app-feedback></app-feedback>

<app-footer></app-footer>